import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    email: "",
    full_name: "",
    role: "",
    phone_number: "",
  },
  reducers: {
    updateUserInformation: (state, action) => {
      Object.assign(state, action.payload);
    },
    clearUserInformation: (state) => {
      state.email = "";
      state.full_name = "";
      state.role = "";
      state.phone_number = "";
    },
  },
});

export const { updateUserInformation, clearUserInformation } = userSlice.actions;

export default userSlice.reducer;
